import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  CreateIssueTemplateRequestDto,
  IssueTemplateUpdatedResponseDto,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

export interface UpdateIssueTemplateParams {
  onError?: (error: ExtendedAxiosError) => void;
}

export function useUpdateIssueTemplate(params?: UpdateIssueTemplateParams) {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<
    IssueTemplateUpdatedResponseDto,
    ExtendedAxiosError,
    { slug: string } & CreateIssueTemplateRequestDto
  >({
    mutationKey: ['issueTemplates'],
    mutationFn: (data) =>
      api.issueTemplatesApi
        .updateIssueTemplate(data.slug, data)
        .then((r) => r.data),
    onError: params?.onError,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ['issue-templates', data.slug],
      });
    },
  });
}
